import { QueryClient as s, MutationCache as u, QueryCache as o } from "@tanstack/react-query";
const r = (t) => {
  const e = t == null ? void 0 : t.response;
  return e == null ? void 0 : e.status;
}, a = (t, e) => {
  const n = r(e);
  return n === 401 || n === 403 || n === 429 ? !1 : t < 2;
}, i = new s({
  defaultOptions: {
    queries: {
      retry: a
    },
    mutations: {
      retry: !1
    }
  },
  queryCache: new o({
    onError: (t) => {
      const e = r(t);
      e === 401 || e === 403 || console.error("Query error:", t);
    }
  }),
  mutationCache: new u({
    onError: (t) => {
      const e = r(t);
      e === 401 || e === 403 || console.error("Mutation error:", t);
    }
  })
});
export {
  i as queryClient
};
